import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateContact } from '../../../../actions/personalInfoAction';

import InlineEdit from '../../../../components/InlineEdit/InlineEdit';
import StaticField from '../../../../components/StaticField/StaticField';
import SaveDialog from '../../../../components/SaveDialog/SaveDialog';

import {PERSONALINFO_PHONE} from '../../../../utils/FieldTypes';
import InputMask from 'react-input-mask';

import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';


class InlineEditPhone extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      saveDialogOpen: false
    };

    this.onClickSave = this.onClickSave.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.toggleSaveDialog = this.toggleSaveDialog.bind(this);
  }
  onClickSave(event) {
    event.preventDefault();
    // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
    this.props.validatePersonalInfoFields(["mobilePhone"], (isValid) => {
      if(isValid) {
        this.props.updateContact(this.props.savedPersonalInfo.email, this.props.mobilePhone, this.props.homePhone, this.props.savedPersonalInfo.accountPassword);
        this.toggleEdit();
      }
      else {
        this.setState({
          saveDialogOpen: false
        })
      }
    });
  }
  toggleEdit() {    
    this.props.updateFieldsFromSavedState(PERSONALINFO_PHONE);
    this.props.countOpenSections(!this.state.edit);
    this.setState({
      edit: !this.state.edit,
      saveDialogOpen: false
    });
  }
  cancelEdit() {
    // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
    if(this.props.mobilePhone === this.props.savedPersonalInfo.mobilePhone && 
       this.props.homePhone === this.props.savedPersonalInfo.homePhone) {
      this.toggleEdit();
    }
    else {
      this.setState({
        saveDialogOpen: true
      })
    }
  }

  toggleSaveDialog() {
    this.setState({
      saveDialogOpen: !this.state.saveDialogOpen
    });
  }
  render() {
    // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
    return (
      <div className="review-inline-edit">
        {!this.state.edit ? 
          <StaticField label="Phone(s)" onClickEdit={this.toggleEdit} hidden={this.state.edit} disableEdit={this.props.sectionsOpen}>
            <Input plaintext value={`Mobile: ${this.props.savedPersonalInfo.mobilePhone}`} readOnly />
            <Input plaintext value={`Home: ${this.props.savedPersonalInfo.homePhone}`} readOnly />
          </StaticField>        
        :
          <InlineEdit onClickSave={this.onClickSave} hidden={!this.state.edit} onClickCancel={this.cancelEdit}>  
            <FormGroup>
              <Label for="mobilePhone">Mobile</Label>
              <InputMask mask="999-999-9999" onChange={this.props.handleChange} onKeyDown={this.props.onKeyDown} onSelect={this.props.onClick} onClick={this.props.onClick} beforeMaskedValueChange={this.props.beforeMaskedValueChange} value={this.props.mobilePhone} onBlur={this.props.validateField} autoFocus={this.props.autoFocus}>
                {(inputProps) => <Input name="mobilePhone" {...inputProps} id="phone" type="tel" invalid={this.props.validation.mobilePhone.isInvalid} autoComplete="tel-national" autoCapitalize="off" autoCorrect="off" />}
              </InputMask>
              <FormFeedback>{this.props.validation.mobilePhone.message}</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="homePhone">Home</Label>
              <InputMask mask="999-999-9999" onChange={this.props.handleChange} onKeyDown={this.props.onKeyDown} onSelect={this.props.onClick} onClick={this.props.onClick} beforeMaskedValueChange={this.props.beforeMaskedValueChange} value={this.props.homePhone} onBlur={this.props.validateField} autoFocus={this.props.autoFocus}>
                {(inputProps) => <Input name="homePhone" {...inputProps} id="phone" type="tel" invalid={this.props.validation.homePhone.isInvalid} autoComplete="tel-national" autoCapitalize="off" autoCorrect="off" />}
              </InputMask>
              <FormFeedback>{this.props.validation.homePhone.message}</FormFeedback>
            </FormGroup>
          </InlineEdit>

        }
        <SaveDialog visible={this.state.saveDialogOpen} toggle={this.toggleSaveDialog} name="Personal Info" onClickSave={this.onClickSave} onClickCancel={this.toggleEdit} />
      </div>);
  }
}
// PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
InlineEditPhone.defaultProps= {
  handleChange:() => {},
  validateField: () => {},
  mobilePhone: "",
  homePhone: "",
  validation: {
    mobilePhone: {
      isInvalid: false,
      message: ""
    },
    homePhone: {
      isInvalid: false,
      message: ""
    }
  },
  authUserIndex: null,
  autoFocus: false
};

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
  // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
  updateContact: (email, mobilePhone, homePhone, accountPassword) => dispatch(updateContact(email, mobilePhone, homePhone, accountPassword))
})


export default connect(mapStateToProps, mapDispatchToProps)(InlineEditPhone);


// WEBPACK FOOTER //
// ./src/containers/Review/InlineEdit/PersonalInfo/Phone.js